module.exports = [
	{
		"value": "1-9",
		"label": "1-9"
	},
	{
		"value": "10-20",
		"label": "10-20"
	},
	{
		"value": "21-50",
		"label": "21-50"
	},
	{
		"value": "50-100",
		"label": "50-100"
	},
	{
		"value": "150+",
		"label": "150+"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assess/question/staffsizes.json
// module id = 430
// module chunks = 0